/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useEffect, useState } from "react";
import SettingsController from "../../api/settings";
import { Link } from "react-router-dom";
import Header from "../../components/public/Header";
import Footer from "../../components/public/Footer";

export default function Home() {
    const [steem, setSteem] = useState(0);

    const getSteem = useCallback(async () => {
        const response = await SettingsController.getSteem();

        if (response.error) {
            return
        }

        setSteem(response.steem);
    }, []);

    useEffect(() => {
        getSteem();
    }, [getSteem]);

    return <section className="home page-template page-template-template page-template-home page-template-templatehome-php page page-id-7 page-parent wp-embed-responsive">
        <Header />

        <main>
            <section className="hero" id="hero">
                <div className="desc">
                    <div className="container">
                        <div className="row fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                            <div className="col-lg-12">
                                <h1>
                                    IOST Mainnet: The Next-Generation Solution
                                </h1>
                                <div className="btn-wrp mt-md-5">
                                    <div className="btn-inner me-sm-2">
                                        <Link to="/dashboard" className="btn btn-primary btn-lg" style={{ fontSize: "3rem" }}>Join</Link>
                                    </div>
                                    <div className="loop-explorer">
                                        <div className="icon">
                                            <div className="inner">
                                                <img alt="" src="/img/q1.png" />
                                            </div>
                                        </div>
                                        <div className="desc-1">
                                            <h6>WebWallet <br /> Testing the network</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="media  -decor-hero">
                    <img alt="" src="/img/03.png" />
                </div>
                <div className="media  mobile-only">
                    <img alt="" src="" style={{ transform: "scale(1.1, 1.1)", opacity: "1" }} />
                </div>
            </section>

            <section className="home-overview">
                <section id="mission" className="first-child">
                    <div className="container">
                        <div className="row section-title fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                            <div className="col-lg-12">
                                <h2>About Solution</h2>
                            </div>
                        </div>
                        <div className="row fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                            <div className="col-lg-12">
                                <div className="loop-border">
                                    <h3>
                                        We pay <span>1.9% - 3.2%</span> of the amount of coins for cooperation to your nickname address after active time for testing the network.
                                    </h3>
                                    <p className="lead lh-200">
                                        You need to register in the Wallet section and make sure that the testnet time is active, otherwise you will not receive the reward.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="mission" className="pt0">
                    <div className="container">
                        <div className="row section-title fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                            <div className="col-lg-12">
                                <h2>Mission</h2>
                            </div>
                        </div>
                        <div className="row fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                            <div className="col-lg-12">
                                <div className="loop-border">
                                    <h3>
                                        IOST is an
                                        <span className="text-brand">ultra-fast, decentralised blockchain network </span>
                                        based on
                                        the next-generation consensus algorithm  <br />
                                        “Proof of Believability” (PoB).
                                    </h3>
                                    <p className="lead lh-200">
                                        Led by a team of proven founders and backed by world-class investors,  our mission is to be the underlying architecture for online services that meets the security and scalability needs of a decentralized economy
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="container">
                    <div className="row section-title fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                        <div className="col-lg-12">
                            <h2 className="text-center">Ultra-fast Blockchain Network </h2>
                            <h5 className="text-center">
                                IOST is ultra-fast, scalable and secure blockchain network based on the next-generation consensus algorithm “Proof of Believability” (PoB). Led by a team of seasoned experts and backed by world-class investors, our mission is to be the underlying architecture for online services that meets the security and scalability needs of a decentralized economy.
                            </h5>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                        <div className="col-lg-4">
                            <div className="loop-stat">
                                <div className="desc">
                                    <h3>
                                        105,563,375                            </h3>
                                    <h5>Market Cap</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="loop-stat">
                                <div className="desc">
                                    <h3>21,315,000,000</h3>
                                    <h5>Circulating Supply</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="loop-stat">
                                <div className="desc">
                                    <h3>{steem}</h3>

                                    <h5>IOST Price</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="home-partners-wrp fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                <div className="home-partners">
                    <div className="scroller">
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/tokocrypto.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/upbit.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/vccexchange.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/wazirx.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/mxe.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/ocenaex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/okex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/indodax.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/kucoin.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/kybernetwork.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/latoken.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/hitbtc.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/hotbit.jpg" />
                        </a>
                    </div>
                    <div className="scroller scroller-right">
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/tokocrypto.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/upbit.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/vccexchange.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/wazirx.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/mxe.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/ocenaex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/okex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/indodax.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/kucoin.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/kybernetwork.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/latoken.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/hitbtc.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/hotbit.jpg" />
                        </a>
                    </div>
                </div>
                <div className="home-partners">
                    <div className="scroller">
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/dragon.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/gate.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/gopax.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coindcx.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coinex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/crypto.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/digifinex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bkek.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coincheck.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coinbene.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/catex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bittrex.jpg" />
                        </a>
                    </div>
                    <div className="scroller scroller-right">
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/dragon.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/gate.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/gopax.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coindcx.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coinex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/crypto.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/digifinex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bkek.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coincheck.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/coinbene.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/catex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bittrex.jpg" />
                        </a>
                    </div>
                </div>
                <div className="home-partners">
                    <div className="scroller">
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitpanda.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitrue.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitasset.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitax.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bithumb-global.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bithumb.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bigone.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/biki.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/binance-jex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/binance.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bione.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/大币网.jpg" />
                        </a>
                    </div>
                    <div className="scroller scroller-right">
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitpanda.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitrue.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitasset.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bitax.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bithumb-global.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bithumb.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bigone.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/biki.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/binance-jex.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/binance.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/bione.jpg" />
                        </a>
                        <a className="item">
                            <img alt="" className="img-fluid" src="/img/logotypes/大币网.jpg" />
                        </a>
                    </div>
                </div>
            </section>





            <section>
                <div className="container">
                    <div className="row section-title  fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                        <div className="col-lg-12">
                            <h2 className="text-center">In the News</h2>
                        </div>
                    </div>
                    <div className="row row-equal-height  fade-item" data-aos="fade-up" data-aos-duration="700" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>

                        <div className="col-lg-4">
                            <a className="loop-news" href="https://medium.com/iost/path-forward-iost-3-0s-roadmap-to-global-adoption-5c2ae4a2e02e" target="_blank" rel="noreferrer">
                                <div className="image">
                                    <img alt="" width="1400" height="788" src="/img/1_6GQmHaD5XcdO8N_lNuq4KA.webp" className="attachment-post-thumbnail size-post-thumbnail wp-post-image" decoding="async" />                                                    </div>
                                <p className="meta">
                                    <span className="date">1 月 3, 2025</span>
                                </p>
                                <div className="desc">
                                    <h6>Path Forward: IOST 3.0’s Roadmap to Global Adoption</h6>
                                </div>
                            </a>
                        </div>

                        <div className="col-lg-4">
                            <a className="loop-news" href="https://medium.com/iost/understanding-iosts-new-tokenomics-e3486e64d7d2" target="_blank" rel="noreferrer">
                                <div className="image">
                                    <img alt="" width="1400" height="788" src="/img/1_rR83MlJaZ-Bdaxi6bQQxcA.webp" className="attachment-post-thumbnail size-post-thumbnail wp-post-image" decoding="async" />                                                    </div>
                                <p className="meta">
                                    <span className="date">1 月 3, 2025</span>
                                </p>
                                <div className="desc">
                                    <h6>Understanding IOST’s New Tokenomics</h6>
                                </div>
                            </a>
                        </div>

                        <div className="col-lg-4">
                            <a className="loop-news" href="https://medium.com/iost/recap-2024-end-of-year-web3-community-party-in-tokyo-3c9bca347e37" target="_blank" rel="noreferrer">
                                <div className="image">
                                    <img alt="" width="700" height="364" src="/img/0_947QzWbXamm6pkqT.webp" className="attachment-post-thumbnail size-post-thumbnail wp-post-image" decoding="async" />                                                    </div>
                                <p className="meta">
                                    <span className="date">1 月 3, 2025</span>
                                </p>
                                <div className="desc">
                                    <h6>Recap: 2024 End-of-Year Web3 Community Party in Tokyo</h6>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <Footer />

    </section>
}